import React from "react";
import LandingFinderUp from "./components/LandingFinderUp";

function App() {
  return <LandingFinderUp />;
}

export default App;